<script setup>
import { computed } from 'vue';

// Barra proporcional em SVG: a largura de cada parte vai no atributo do <rect>, não
// em style, e a cor vem de uma classe fill-* do tema.
const props = defineProps({
  // [{ key, value, fill }] — fill é uma classe estática, ex.: 'fill-n-teal-9'.
  segments: { type: Array, default: () => [] },
  // Sem total, as partes dividem a barra inteira entre si.
  total: { type: Number, default: null },
});

const parts = computed(() => {
  const total =
    props.total ?? props.segments.reduce((sum, part) => sum + part.value, 0);
  let offset = 0;
  return props.segments.map(segment => {
    const width = total > 0 ? (segment.value / total) * 100 : 0;
    const part = { ...segment, x: `${offset}%`, width: `${width}%` };
    offset += width;
    return part;
  });
});
</script>

<template>
  <div class="overflow-hidden w-full rounded-full bg-n-alpha-2">
    <svg class="block w-full h-full" aria-hidden="true">
      <rect
        v-for="part in parts"
        :key="part.key"
        :x="part.x"
        y="0"
        :width="part.width"
        height="100%"
        :class="part.fill"
      />
    </svg>
  </div>
</template>
